import { render } from "./BaseStationFormHeader.vue?vue&type=template&id=b1488834&scoped=true"
import script from "./BaseStationFormHeader.vue?vue&type=script&lang=js"
export * from "./BaseStationFormHeader.vue?vue&type=script&lang=js"

import "./BaseStationFormHeader.vue?vue&type=style&index=0&id=b1488834&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1488834"]])

export default __exports__